"use client"

import { Button } from "@/components/ui/button"
import {
   Form,
   FormControl,
   FormField,
   FormItem,
   FormLabel,
   FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { authClient } from "@/lib/auth-client"
import { formSchema } from "@/lib/auth-schema"
import { SIGNUP_SOURCES } from "@/lib/signup-source"

import { zodResolver } from "@hookform/resolvers/zod"
import { redirect } from "next/navigation"
import { useForm } from "react-hook-form"
import { toast } from "sonner"
import { z } from "zod"


export default function SignUpForm() {
   const form = useForm<z.infer<typeof formSchema>>({
      resolver: zodResolver(formSchema),
      defaultValues: {
         name: "",
         email: "",
         password: "",
         signupSource: undefined,
      },
   })

   async function onSubmit(values: z.infer<typeof formSchema>) {
      const { name, email, password, signupSource } = values;
      await authClient.signUp.email({
         email,
         password,
         name,
         signupSource,
      }, {
         onRequest: () => {
            toast("Signing up...")
         },
         onSuccess: () => {
            form.reset()
            redirect("/sign-in")
         },
         onError: (ctx) => {
            toast.error(ctx.error.message);
         },
      });
   }

   return (
      <Form {...form}>
         <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
               control={form.control}
               name="name"
               render={({ field }) => (
                  <FormItem>
                     <FormLabel>Name</FormLabel>
                     <FormControl>
                        <Input placeholder="John Doe" {...field} />
                     </FormControl>
                     <FormMessage />
                  </FormItem>
               )}
            />
            <FormField
               control={form.control}
               name="email"
               render={({ field }) => (
                  <FormItem>
                     <FormLabel>Email</FormLabel>
                     <FormControl>
                        <Input placeholder="m@example.com" {...field} />
                     </FormControl>
                     <FormMessage />
                  </FormItem>
               )}
            />
            <FormField
               control={form.control}
               name="password"
               render={({ field }) => (
                  <FormItem>
                     <FormLabel>Password</FormLabel>
                     <FormControl>
                        <Input type="password" placeholder="********" {...field} />
                     </FormControl>
                     <FormMessage />
                  </FormItem>
               )}
            />
            <FormField
               control={form.control}
               name="signupSource"
               render={({ field }) => (
                  <FormItem>
                     <FormLabel>Comment as-tu connu LycéoLearn ? (facultatif)</FormLabel>
                     <FormControl>
                        <select
                           {...field}
                           className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                        >
                           <option value="">Préfère ne pas répondre</option>
                           {SIGNUP_SOURCES.map(({ value, label }) => (
                              <option key={value} value={value}>{label}</option>
                           ))}
                        </select>
                     </FormControl>
                     <FormMessage />
                  </FormItem>
               )}
            />
            <Button type="submit" className="w-full">
               Register
            </Button>
         </form>
      </Form>
   )
}
